import { createSelector } from '@reduxjs/toolkit';
import { getState } from '@yme/selectors/common';
export const getCycleSchemeState = createSelector(getState, (state) => state.cycleScheme);
export const getIsCertificateValidating = createSelector(getCycleSchemeState, (state) => state.isValidating);
export const getValidationResult = createSelector(getCycleSchemeState, (state) => state.validationResult);
export const getCertificateCode = createSelector(getCycleSchemeState, (state) => state.certificateCode);
export const getHasValidationError = createSelector(getCycleSchemeState, (state) => state.hasError);
export const getHasRedemptionError = createSelector(getCycleSchemeState, (state) => state.hasRedemptionError);
export const getRedemptionValidationResult = createSelector(getCycleSchemeState, (state) => state.redemptionValidationResult);
